<template>
  <div>

    <body data-anchor="pagetop" class="home page-template-default page page-id-314 wp-embed-responsive st-Grid_Container" style="overflow-y: unset;">
      <navbar follow="st-Header" imgSrc="../../../../static/img/logo/logo-black.png"></navbar>
      <div class="st-FixedPoint"></div>
      <div class="st-MainContainer">
        <main class="st-MainContents" style="padding-top: 120px;">

          <header class="series-PageTitle">
            <div class="series-PageTitle_Inner" data-appear>
              <h1>
                <span class="series-PageTitle_Logo">SERVICE</span>
                <span class="series-PageTitle_Title" style="color:#FFF">サービス案内</span>
              </h1>
              <div class="sw-parallax">
                <div class="sw-parallax_outer js-parallax_outer">
                  <div class="sw-parallax_inner">
                    <div class="sw-parallax_block js-parallax_block">
                      <div class="sw-parallax_target promotion-PageTitle-visual" style="background: url(../../../../static/img/service/top.jpg) 50%/cover no-repeat;top: 70px;height: 480px;"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </header>

          <section class="service-index-project-common">
            <div class="company-Profile_Inner pb-md-6 pb-6">
              <div class="st-Grid_Inner p-0 service-index-appear-1" data-appear="true">
                <h2 class="common-text-appear text-center service-index-appear-2" data-appear="true">
                  <span class="sw-Section_Header-en pb-3">
                    <b>
                      <font>
                        <font>システム受託開発</font>
                      </font>
                    </b>
                  </span>
                </h2>
              </div>

              <div class="row mx-0 mt-6 mt-md-8">
                <div class="common-image-appear service-index-appear-3 col-md-6 p-0" data-appear="true">
                  <picture class="mb-0"><img src="../../../../static/img/service/develop.jpg" alt=""></picture>
                </div>
                <div class="top-card_Row-common service-index-appear-4 pr-0 pl-0 col-md-6 p-0" data-appear>
                  <div class="top-card_Row-text-common service-index-appear-5" data-appear>
                    <div class="px-5 py-4 text">
                      弊社は受託開発のサービスをご提供しています。<br />業務アプリケーション、インフラ構築、組込みソフト、
                      物流管理システムなど幅広い開発ノウハウを持っており、企画からの受託開発サービスをご提供可能です。
                      お客様へ付加価値の高いシステムのご提案をお任せて下さい。
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section class="service-index-project-common">
            <div class="company-Profile_Inner pb-md-6 pb-6">
              <div class="st-Grid_Inner p-0 service-index-appear-6" data-appear="true">
                <h2 class="common-text-appear text-center service-index-appear-7" data-appear="true">
                  <span class="sw-Section_Header-en pb-3">
                    <b>
                      <font>
                        <font>ロボティクス自動化エンジニアリングサービス</font>
                      </font>
                    </b>
                  </span>
                </h2>
              </div>

              <div class="row mx-0 mt-6 mt-md-6">
                <div class="common-image-appear service-index-appear-8 col-md-12 p-0" data-appear="true">
                  <picture class="mb-0"><img src="../../../../static/img/service/01.jpg" alt=""></picture>
                </div>
              </div>
            </div>
          </section>

        </main>
        <div class="st-Breadcrumbs">
          <ul class="st-BreadcrumbsList" itemscope="itemscope" itemtype="">
            <li class="st-BreadcrumbsList_Item" itemprop="itemListElement" itemscope="itemscope" itemtype="">
              <router-link class="st-BreadcrumbsList_Item-link" to="/" itemprop="item">ホーム</router-link>
              <meta itemprop="position" content="1">
            </li>
            <li class="st-BreadcrumbsList_Item" itemprop="itemListElement" itemscope="itemscope" itemtype="">
              <p itemprop="item" aria-current="page" style="margin-bottom: 0rem;"><span itemprop="name">サービス案内</span></p>
              <meta itemprop="position" content="3">
            </li>
          </ul>
        </div>
      </div>
      <copyright></copyright>
    </body>
  </div>
</template>
<style />
<script type="text/javascript">
import copyright from './../copyright'
import navbar from './../navbar'
import Swiper from 'swiper/swiper-bundle.js'
import 'swiper/swiper-bundle.css'
import newsList from '../../../../static/js/news-list.js'

export default {
  components: { copyright, navbar },
  data: function () {
    return {
      newsList: newsList
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    onChangeFontSize(length) {
      if (length > 18) {
        return 'font-size:1.25rem'
      } else if (length > 16) {
        return 'font-size:1.4rem'
      } else if (length > 15) {
        return 'font-size:1.5rem'
      }
    },
    projectDetail(projectId) {
      this.$router.push({
        path: '/service/project-detail',
        query: {
          projectId: projectId
        }
      });

    },
    init() {
      $('.series-PageTitle_Inner').eq(0).addClass('appear')
      $('.service-index-appear-1').addClass('st-Grid_Inner_appear')
      $('.service-index-appear-2').addClass('appear')
      $('.service-index-appear-3').addClass('appear')
      $('.service-index-appear-4').addClass('appear')
      $('.service-index-appear-5').addClass('appear')
      
      new Swiper('.service-index-project-slide', {
        slidesPerView: 'auto',
        navigation: {
          nextEl: '.swiper-button-next-project',
          prevEl: '.swiper-button-prev-project'
        }
      })

      new Swiper('.service-index-development-slide', {
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 0
          },
          769: {
            slidesPerView: 3,
            spaceBetween: 20
          }
        },
        navigation: {
          nextEl: '.swiper-button-next-development',
          prevEl: '.swiper-button-prev-development'
        },
      })

      // element.offsetHeight
      $(document).scroll(() => {

        if (this.$route.path != '/service/index') {
          return false
        }

        let scroH = $(document).scrollTop()
        let viewW = $(window).width()
        if (scroH > 50) {
          $('.st-Header').addClass('is-follow')
          $('.st-Footer_Pagetop').addClass('is-follow')
        } else {
          $('.st-Header').removeClass('is-follow')
          $('.st-Footer_Pagetop').removeClass('is-follow')
        }

        if (viewW > 769) {
          if (scroH >= 300) {
            $('.series-PageTitle_Inner').eq(0).removeClass('appear')
          } else {
            $('.series-PageTitle_Inner').eq(0).addClass('appear')
          }

          if (scroH > 280 && scroH < 1300) {
            $('.service-index-appear-6').addClass('st-Grid_Inner_appear')
            $('.service-index-appear-7').addClass('appear')
          } else {
            $('.service-index-appear-6').removeClass('st-Grid_Inner_appear')
            $('.service-index-appear-7').removeClass('appear')
          }

          if(scroH > 300){
            $('.service-index-appear-8').addClass('appear')
          }else{
            $('.service-index-appear-8').removeClass('appear')
          }

          if (scroH > 700) {
            $('.service-index-appear-1').removeClass('st-Grid_Inner_appear')
            $('.service-index-appear-2').removeClass('appear')
          } else {
            $('.service-index-appear-1').addClass('st-Grid_Inner_appear')
            $('.service-index-appear-2').addClass('appear')
          }

          
        } else {
          $('.series-PageTitle_Inner').eq(0).addClass('appear')
          $('.service-index-appear-1').addClass('st-Grid_Inner_appear')
          $('.service-index-appear-2').addClass('appear')
          $('.service-index-appear-3').addClass('appear')
          $('.service-index-appear-4').addClass('appear')
          $('.service-index-appear-5').addClass('appear')
          $('.service-index-appear-6').addClass('st-Grid_Inner_appear')
          $('.service-index-appear-7').addClass('appear')
          $('.service-index-appear-8').addClass('appear')
        }
      })
    }
  }
}
</script>
<style scoped src="../../../../static/css/service.css">
</style>



// WEBPACK FOOTER //
// src/components/pages/service/service.vue